import {
  setEmail,
  setName,
  setPhone,
  UserState
} from '@portalterreno/nextjs-client/redux/slices/user';
import { all, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  sendLegacyProjectContact,
  sendLegacyProjectShowPhoneContact,
  sendLegacyProjectWhatsappContact,
  sendLegacyTerrainContact,
  sendLegacyTerrainShowPhoneContact,
  sendLegacyTerrainWhatsappContact,
  setStatus
} from '../slices/contactForm';
// import { setIsValid } from '../slices/user';
import { RootState } from '../store';
// eslint-disable-next-line import-length/import-length
import { sendLegacyProjectContactFormWorker } from './watchLegacyProjectContactForm';
// eslint-disable-next-line import-length/import-length
import { sendLegacyTerrainContactFormWorker } from './watchLegacyTerrainContactForm';

type ValidationParameters = Pick<UserState, 'email' | 'name' | 'phone'>;

export function* contactFormWorker(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  worker: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
) {
  const state: ValidationParameters = yield select((state: RootState) => ({
    name: state.user.name,
    email: state.user.email,
    phone: state.user.phone
  }));

  let hasError = false;

  if (!state.name.isValid || !state.name.value) {
    hasError = true;

    yield put(
      setName({
        ...state.name,
        isValid: false
      })
    );
  }

  if (!state.email.isValid || !state.email.value) {
    hasError = true;

    yield put(
      setEmail({
        ...state.email,
        isValid: false,
        variant: 'error',
        message: 'enterValidEmail'
      })
    );
  }

  if (!state.phone.isValid || !state.phone.value) {
    hasError = true;

    yield put(
      setPhone({
        ...state.phone,
        isValid: false
      })
    );
  }

  if (hasError) {
    yield put(setStatus('initial'));
  } else {
    yield fork(worker, action);
  }
}

export default function* watchContactForm() {
  yield all([
    takeLatest(
      [
        sendLegacyProjectContact,
        sendLegacyProjectWhatsappContact,
        sendLegacyProjectShowPhoneContact
      ],
      contactFormWorker,
      sendLegacyProjectContactFormWorker
    ),
    takeLatest(
      [
        sendLegacyTerrainContact,
        sendLegacyTerrainWhatsappContact,
        sendLegacyTerrainShowPhoneContact
      ],
      contactFormWorker,
      sendLegacyTerrainContactFormWorker
    )
  ]);
}
